import Config from '@/shared/constants/config';

const Actions = {
  LoadAll: {
    START: 'resources.policies.actions.load-all.start',
    SUCCESS: 'resources.policies.actions.load-all.success',
    FAILED: 'resources.policies.actions.load-all.failed'
  }
};

const Mutations = {
  SET: 'resources.policies.mutations.set',
  CLEAR: 'resources.policies.mutations.clear',

  IsLoading: {
    SET: 'resources.policies.mutations.is-loading.set',
    CLEAR: 'resources.policies.mutations.is-loading.clear'
  },

  Errors: {
    SET: 'resources.policies.mutations.errors.set',
    CLEAR: 'resources.policies.mutations.errors.clear'
  }
};

const Endpoints = {
  LoadAll: (employerId) => `${Config.API.BASE_URL}/api/Employers/${employerId}/Policies`
};

export default {
  Actions,
  Mutations,
  Endpoints
};
